import { render } from "./wColor.vue?vue&type=template&id=65fb65d4&ts=true"
import script from "./wColor.vue?vue&type=script&lang=ts"
export * from "./wColor.vue?vue&type=script&lang=ts"

import exportComponent from "E:\\Work\\Sales point\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__